import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=77c5c6c8&"
import script from "./GamePage.vue?vue&type=script&lang=js&"
export * from "./GamePage.vue?vue&type=script&lang=js&"
import style0 from "./GamePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports